/**
 *  WidgetsDescriptions script file
**/

import apiService from '@/api/apiService'
import { analyses } from '@/api/widgets'
import authService, { USER_ROLES } from '@/api/authService'

export default {
  name: 'WidgetsDescriptions',
  mixins: [],
  components: {
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/common/modal/Modal.vue')
  },
  props: {
    center: {
      type: Object,
      required: true
    },
    areas: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      analyses: analyses.map(a => ({ ...a, showFullDescription: false })),
      showInfoModal: false
    }
  },
  computed: {
    centerid () {
      return this.$route.params.id
    }
  },
  mounted () {
    this.setupWidgetDescriptions()
  },
  methods: {
    toggleFullDescription (widget) {
      widget.showFullDescription = !widget.showFullDescription
      this.$nextTick(() => {
        this.$emit('toggle')
      })
    },
    setupWidgetDescriptions () {
      for (const widget of this.analyses) {
        widget.description = this.center[widget.description_field]
      }
    },
    canEditWidget () {
      const auth = authService.getAuth()
      return auth.role === USER_ROLES.ADMIN
    },
    getWidgetPlaceholder () {
      return this.canEditWidget() ? 'Pulse para escribir una descripción' : 'Sin descripción'
    },
    onDropdownToggle (widget) {
      this.closeDescriptionEdit(widget)
      window.setTimeout(() => {
        this.$emit('toggle')
      }, 300)
    },
    toggleDescriptionEdit (widget) {
      widget.edit = true
    },
    closeDescriptionEdit (widget) {
      widget.description = this.center[widget.description_field]
      widget.edit = false
    },
    async saveWidgetDescription (widget) {
      widget.loading = true
      try {
        await apiService.updateWidgetDescription({
          centerId: this.centerid,
          descriptionField: widget.description_field,
          description: widget.description
        })
        this.center[widget.description_field] = widget.description
        this.closeDescriptionEdit(widget)
      } catch (err) {
        // eslint-disable-next-line
        console.error('[shop-detail.js] Error saving widget description', err)
      }
      widget.loading = false
    },
    getAnalysisLink (widget) {
      return {
        name: 'shop-analysis',
        params: { id: this.centerid, type: widget.key }
      }
    },
    toggleInfoModal (flag) {
      this.showInfoModal = flag
    }
  }
}
